import { styled } from '@volkswagen-onehub/components-core';
import React, { useContext } from 'react';
import BuildYourDeal from '../../../components/BuildYourDeal';
import { VehicleData } from '../../../types';
import { VehicleDetailsContext } from '../../../utils/details-context';

const Container = styled.div`
  display: flex;
  column-gap: ${({theme}) => theme.size.static200};
  padding-top: ${({theme}) => theme.size.dynamic0040}
`;

const BuildCta = () => {
  const vehicle = useContext(VehicleDetailsContext).vehicle as VehicleData;
  return (
    <Container>
      <BuildYourDeal vehicle={vehicle} />
      {/* <Batd label={trans.details.batd.cta} /> */}
    </Container>
  );
};

export default BuildCta;
